import { DataModel } from "@essenza/core";

export function CategoryModel() {
    DataModel.call(this, "category");

    this.list = ()=>{
        return this.ExecuteQuery(`list: [category]  {*, -O tname
        }`, null, true);
      }
}